import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

const FRACTIONAL_PART_PATTERN = /([.,]\d+)$/;
const COLOR_CLASS = {
  gray: 'f-muted',
  green: 'f-success',
  red: 'f-danger',
} as const;

@Pipe({
  name: 'numberDecoration',
})
export class NumberDecorationPipe implements PipeTransform {
  public transform(
    value: string | null,
    options?: {
      unit?: string;
      color?: keyof typeof COLOR_CLASS;
    },
  ): string {
    if (value == null) return '';

    const { unit } = options ?? {};
    const color = COLOR_CLASS[options?.color ?? 'gray'];

    const unitSpacing = unit ? (unit === '%' ? '' : ' ') : '';
    const decoration = `${unitSpacing}${unit ?? ''}`;

    if (!FRACTIONAL_PART_PATTERN.test(value)) {
      return `${value}<span class="${color}">${decoration}</span>`;
    }

    return value.replace(FRACTIONAL_PART_PATTERN, (fractional) => {
      return `<span class="${color}">${fractional}${decoration}</span>`;
    });
  }
}
